import { Textarea } from "@stardust-ds/react"
import { useEffect } from "react"
import Button from "../../atoms/Button"
import Modal from "../Modal"
import intl from "react-intl-universal"

import styles from "./index.module.scss"

export default function RcmpModalEditComment(props) {
  const {
    bIsOpen,
    fnHandleConfirm,
    fnCancelEdit,
    cOldValue,
    handleSubmit,
    register,
    setValue,
    label,
    bIsLoading,
  } = props

  useEffect(() => {
    if (!cOldValue) return
    setValue("cEditText", cOldValue)
  }, [bIsOpen])

  return (
    <Modal isOpen={bIsOpen} size={"md"}>
      <Modal.Header onClose={fnCancelEdit}>{label}</Modal.Header>
      <form
        onSubmit={handleSubmit(fnHandleConfirm)}
        className={styles.container}
      >
        <Modal.Content>
          <div className={styles.contentContainer}>
            <Textarea
              type={"text"}
              isRequired
              isFullWidth
              label={label[0].toUpperCase() + label.substr(1).toLowerCase()}
              placeholder={intl.get("ActivityEvidence.edit_text_placeholder")}
              {...register("cEditText")}
            />
          </div>
        </Modal.Content>
        <Modal.Footer>
          <div className={styles.buttonContainer}>
            <Button variant="outline" type="button" onClick={fnCancelEdit} disabled={bIsLoading}>
              {intl.get("cancel")}
            </Button>
            <Button variant="primary" type="submit" isLoading={bIsLoading}>
              {intl.get("save_changes")}
            </Button>
          </div>
        </Modal.Footer>
      </form>
    </Modal>
  )
}
